<template>
  <div>
    <div class="instructions" id="instructions">
      <div class="instructions__top">
        <div tabindex=0 class="instructions__top__button instructions__top__button--open" @click="toggler" v-on:keyup.enter="toggler">{{$t('cards.toggle')}}</div>
        <div tabindex=0 class="instructions__top__close instructions__top__close--show" @click="toggler" v-on:keyup.enter="toggler"><span>{{$t('cards.button')}}</span></div>
      </div>
      <div class="instructions__boxes instructions__boxes--show">

        <div
          v-for="(c,i) in cards"
          :key="i"
          class="instructions__boxes__box"
        >
          <img :src="getImgUrl(c.image)" class="instructions__boxes__box__img" :alt="`Before you begin ${i+1}`">
          <div class="instructions__boxes__box__number"><span>{{i+1}}</span></div>
          <div class="instructions__boxes__box__text">{{ $t(`cards.${filter}.c${i+1}`) }}</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
//import equipments from '@/equipments.json'
export default {
  name: 'CardsComponent',
  data() {
    return {
      allCards: [
        {
          image:'socket.png',
          filter:{
            internet: true,
            internetWifi: true,
            internetTv: true,
            internetWifiTv: true,
            tv: true,
          }
        },{
          image:'flat.png',
          filter:{
            internet: false,
            internetWifi: false,
            internetTv: true,
            internetWifiTv: true,
            tv: true,
          }
        },{
          image:'coverage.png',
          filter:{
            internet: true,
            internetWifi: true,
            internetTv: false,
            internetWifiTv: false,
            tv: false,
          }
        },{
          image:'devices.png',
          filter:{
            internet: true,
            internetWifi: true,
            internetTv: true,
            internetWifiTv: true,
            tv: false,
          },
        },{
          image:'receiver.png',
          filter:{
            internet: false,
            internetWifi: false,
            internetTv: true,
            internetWifiTv: true,
            tv: true,
          }
        },
      ],
    }
  },
  props:{
    filter:{
      type: String,
      required: true,
    }
  },
  computed:{
    cards(){
      return this.allCards.filter(c=>{
        return c.filter[this.filter]
      })
    }
  },
  methods:{
    getImgUrl(name) {
      let images = require.context('../assets/')
      return images('./' + name )
    },
    toggler(){
      document.querySelector('.instructions__top__button').classList.toggle('instructions__top__button--closed');
      document.querySelector('.instructions__top__button').classList.toggle('instructions__top__button--open');
      document.querySelector('.instructions__top__close').classList.toggle('instructions__top__close--show');
      document.querySelector('.instructions__boxes').classList.toggle('instructions__boxes--show');
    }
  }
}
</script>

<style scoped>
.instructions {
  max-width: 1115px;
  margin: 0 auto;
  margin-top: 30px;
}
.instructions .instructions__top {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  position: relative;
  margin-bottom: 10px;
  margin-top: -5px;
}
.instructions .instructions__top__button {
  font-weight: bolder;
  font-size: 22px;
  text-transform: uppercase;
  color: #000;
  cursor: pointer;
  line-height: 61px;
}
.instructions .instructions__top__button--closed {
  text-decoration: underline;
}
.instructions .instructions__top__button--closed::after {
  content: "›";
  font-size: 44px;
  line-height: 53px;
  font-weight: normal;
  vertical-align: middle;
  display: inline-block;
  margin-left: 15px;
  -webkit-transition: -webkit-transform 0.3s 0.1s linear;
  transition: -webkit-transform 0.3s 0.1s linear;
  transition: transform 0.3s 0.1s linear;
  transition: transform 0.3s 0.1s linear, -webkit-transform 0.3s 0.1s linear;
  margin-bottom: 8px;
  text-decoration: none;
}
.instructions .instructions__top__button--open::after {
  content: "›";
  font-size: 2em;
  font-weight: normal;
  vertical-align: middle;
  display: inline-block;
  -webkit-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
          transform: rotate(90deg);
  margin-left: 15px;
  -webkit-transition: -webkit-transform 0.3s linear;
  transition: -webkit-transform 0.3s linear;
  transition: transform 0.3s linear;
  transition: transform 0.3s linear, -webkit-transform 0.3s linear;
  margin-bottom: 0.8px;
}
.instructions .instructions__top__close {
  position: absolute;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
          transform: translateY(-50%);
  padding: 2px 10px;
  border: 1px solid #dedede;
  text-transform: uppercase;
  font-family: "Gotham-Light", sans-serif;
  font-weight: bolder;
  font-size: 14px;
  background-color: #fff;
  color: #000;
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  -webkit-transition: opacity 0.5s;
  transition: opacity 0.5s;
}
.instructions .instructions__top__close--show {
  opacity: 1;
  pointer-events: auto;
}
.instructions .instructions__top__close::after {
  content: "⊗";
  display: inline-block;
  font-size: 1.4em;
  margin-left: 5px;
}

.instructions__boxes {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  max-width: 100%;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin-bottom: 20px;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  -webkit-transition: all 0.5s linear;
  transition: all 0.5s linear;
}

.instructions__boxes--show {
  max-height: 400px;
  opacity: 1;
  margin-bottom: 30px;
  width: 100%;
}

.instructions__boxes__box {
  max-width: 24%;
  background-color: #fff;
  color: #000;
  border: 1px solid #dedede;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.instructions__boxes__box__img {
  width: 100%;
  border-bottom: 5px solid #dedede;
}

.instructions__boxes__box__number {
  font-family: "Gotham-Bold", sans-serif;
  font-size: 18px;
  color: #1757c6;
  padding: 5px 0;
}

.instructions__boxes__box__text {
  padding: 0 7px 12px 7px;
}

.instructions__boxes__box:not(:first-child) {
  margin-left: 15px;
}



@media (max-width: 1250px) {
  .instructions {
    width: 600px;
    max-width: 100%;
  }
  .instructions__boxes {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    width: 100%;
  }
  .instructions__boxes__box {
    width: 99%;
    min-height: 100px;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
        -ms-flex-direction: row;
            flex-direction: row;
    min-width: 99%;
	align-items: center;
  }
  .instructions__boxes--show {
    max-height: none;
    padding: 2px 0;
  }
  .instructions__boxes__box__img {
    width: auto;
    height: 100%;
    max-height: 100px;
    border-bottom: none;
    border-right: 5px solid #dedede;
  }
  .instructions__boxes__box__number {
    margin: auto 10px auto 10px;
  }
  .instructions__boxes__box__text {
    margin: auto 0;
    max-width: 54%;
    text-align: left;
    padding: 0 5px 0 0;
  }
  .instructions__boxes__box:not(:first-child) {
    margin-left: 0;
    margin-top: 15px;
  }
}
@media (max-width: 600px) {
  .instructions .instructions__top__button {
    font-size: 18px;
  }
	.instructions {
		max-width: 90%;
	}

	

	.instructions__boxes__box__text {
		padding: 5px;
	}

	.instructions__boxes__box {
		min-height: auto;
	}

	.instructions__boxes__box__number {
		padding: 0 5px;
		margin: 0;
		align-self: stretch;
		display: flex;
		border-left: 1px solid #dedede;
	}

	.instructions__boxes__box__number > span {
		align-self: center;
	}

	.instructions__boxes__box__img {
		border-right: 0;
	}
  
}
@media (max-width: 480px) {
  .instructions__boxes__box__img {
    width: 100px;
    -o-object-fit: contain;
       object-fit: contain;
	height: 100px;
  }
  .instructions__boxes__box__text {
    font-size: 14px;
  }
  .instructions .instructions__top__close > span {
    display: none !important;
  }


  .instructions .instructions__top__close {
	padding: 2px 5px;
  }

  .instructions .instructions__top__close:after {
	margin-left: 0;
  }
}
</style>
